import * as React from 'react';
import { BaseComponent } from './BaseComponent';

import utils = egr.wcf.utils;

export interface LoadingCounterProps {
    listenableEvent: utils.ListenableEvent<number | null, unknown>;
    hideIfZero?: boolean;
}

interface LoadingCounterState {
    value: number;
}

export class LoadingCounter extends BaseComponent<LoadingCounterProps, LoadingCounterState> {
    public componentWillMount(): void {
        if (this.props.listenableEvent != null) {
            this.props.listenableEvent.addListener(this.update);
        }

        this.setState({value: 0});
    }

    public componentWillUnmount(): void {
        if (this.props.listenableEvent != null) {
            this.props.listenableEvent.removeListener(this.update);
        }
    }

    public render(): JSX.Element | null {
        if (
            this.props.listenableEvent == null ||
            isNaN(this.state.value) ||
            (this.state.value === 0 && this.props.hideIfZero === true)
        ) {
            return null;
        }

        return <div className="ui-core-loading-counter">{this.asString(this.state.value)}</div>;
    }

    protected update = (value?: number | null): void => {
        if (value != null) {
            this.setState({value: value});
        }
    };

    protected asString(value: number): string {
        if (value < 10) {
            return '0' + value.toString();
        }

        return value.toString();
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoadingCounter.tsx